module.exports = __webpack_public_path__ + "static/media/sakerhet.8763568d.png";